import { useAuth } from '../contexts/AuthContext';
import { getUserRoles } from '../services/roleApi';
import { isSellerRole } from '../utils/roles';

/**
 * Hook to get the user's current active role from the authenticated user
 *
 * @returns {string|null} The current role or null if not authenticated
 */
export function useEffectiveRole() {
  const { currentRole } = useAuth();
  return currentRole || null;
}

/**
 * Hook to check if the user has a specific effective role
 *
 * @param {string} roleToCheck - The role to check for
 * @returns {boolean}
 */
export function useHasEffectiveRole(roleToCheck) {
  const { currentRole, currentUser } = useAuth();

  if (!currentUser) return false;
  return currentRole === roleToCheck;
}

/**
 * Hook to check if user is an effective buyer (considering active role)
 * @returns {boolean}
 */
export function useIsEffectiveBuyer() {
  return useHasEffectiveRole('buyer');
}

/**
 * Hook to check if user is an effective shop user (shop_owner or employee)
 * @returns {boolean}
 */
export function useIsEffectiveShopUser() {
  const { currentRole, currentUser } = useAuth();

  if (!currentUser) return false;
  return isSellerRole(currentRole);
}

export function useHasRole(roleToCheck) {
  const { currentUser } = useAuth();
  if (!currentUser) return false;
  return getUserRoles(currentUser).includes(roleToCheck);
}
